import { useCookieConsent } from '@/contexts/CookieContext';

/**
 * Footer component with legal links and cookie preferences
 * @returns {JSX.Element} Footer component
 */
const Footer = () => {
  const { resetConsent } = useCookieConsent();

  /**
   * Handle cookie preferences click
   */
  const handleCookiePreferences = () => {
    resetConsent();
  };

  return (
    <footer className="bg-primary text-white py-4">
      <div className="container mx-auto text-center">
        <p className="text-sm">
          &copy; {new Date().getFullYear()} Patriot Claims. All rights reserved.
        </p>
        {/* Links to terms and conditions and privacy policy */}
        <div className="mt-2 flex flex-wrap justify-center items-center gap-2">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://patriotclaims.com/legal-disclosures/"
            className="text-gray-400 text-sm hover:text-white"
          >
            Terms and Conditions
          </a>
          <span className="text-gray-400">|</span>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://patriotclaims.com/privacy-policy/"
            className="text-gray-400 text-sm hover:text-white"
          >
            Privacy Policy
          </a>
          <span className="text-gray-400">|</span>
          <button
            onClick={handleCookiePreferences}
            className="text-gray-400 text-sm hover:text-white underline-offset-2 hover:underline cursor-pointer"
            aria-label="Manage cookie preferences"
          >
            Cookie Preferences
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
